import initializeDataTable from './initialize';

/**
 * This vanilla version of DataTables is setup to work off of data attributes you add to an element
 * 1. Add the class '.datatable' to your table element
 * 2. Update the following options if your use case requires a new option. To update
 *    set a new default value in the options object, and then check the element for the
 *    data attribute and turn on that option like `if element.dataset.something...`
 *
 * Usage
 * Docs for library: https://github.com/fiduswriter/Simple-DataTables
 *
 * Make it:
 * - searchable:          data-datatables-search="true"
 * - sortable:            data-datatables-sortable="true"
 * - paginated:           data-datatables-paging="10" where value is per page value
 * - fixed height:        default is true, so turn this off with data-datatables-fixed-height="false"
 * - show next/prev nav:  data-datatables-next-prev="true"
 */
document.addEventListener('turbo:load', () => {
  // Initialize datatables
  initializeDataTable();
});
